export enum MpSnackbarTypes {
  SUCCESS = 'success',
  ERROR = 'error',
  INFO = 'info',
}

export interface MpSnackbarOptions<TData> {
  duration?: number;
  panelClass?: string | string[];
  data?: TData;
}
